/* eslint-disable no-param-reassign */
import produce from 'immer';
import initialState from 'redux/reducers/clonotypes/initialState';
var clonotypesLoaded = produce(function (draft) {
  draft.loaded = true;
  draft.loading = false;
  draft.error = false;
}, initialState);
export default clonotypesLoaded;